// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDTeHRfkIj8f6JIhAnNYVbPgyOhrg4JEJ8",
  authDomain: "englivision-6e9fb.firebaseapp.com",
  projectId: "englivision-6e9fb",
  storageBucket: "englivision-6e9fb.firebasestorage.app",
  messagingSenderId: "832586233645",
  databaseURL: "https://eraasoft-2d9c4-default-rtdb.firebaseio.com/",
  appId: "1:832586233645:web:62a80118ffe01edd7c05a4",
  measurementId: "G-PD1LCRNJY7",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export default app
